export default "__VITE_ASSET__BZBfg$sa__"